import { useStyletron } from 'baseui';

export function IconPipe({ height, width, color }: any) {
    return (
        <svg width={width || '100%'} height={height || '100%'} viewBox="0 0 48 48" x="0px" y="0px">
            <path fill={color} d="M47,35.5H43a1,1,0,0,0-1,1V37H31V32.91a6,6,0,1,0-2,0V37H21a1,1,0,0,0-1-1H16a1,1,0,0,0-1,1H11V6a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1H1A1,1,0,0,0,0,1V5A1,1,0,0,0,1,6V42a5,5,0,0,0,5,5h9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1H42.15a1,1,0,0,0,.85.5h4a1,1,0,0,0,1-1v-10A1,1,0,0,0,47,35.5ZM26,27a4,4,0,1,1,4,4A4,4,0,0,1,26,27ZM42,39v6H21V39ZM2,2h8V4H2ZM6,45a3,3,0,0,1-3-3V6H9V38a1,1,0,0,0,1,1h5v6Zm11,1V38h2v8Zm29-.5H44v-8h2ZM30,28a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l1-2a1,1,0,0,1,1.78.9l-1,2A1,1,0,0,1,30,28Z">
            </path></svg>

    );
}
